"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVinValid = exports.getInvalidVINLetter = void 0;
var getInvalidVINLetter = function (vin) {
    var _a, _b, _c;
    if (vin === void 0) { vin = ''; }
    return (_c = (_b = (_a = vin.match(/[ioq]/gi)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.toUpperCase()) !== null && _c !== void 0 ? _c : '';
};
exports.getInvalidVINLetter = getInvalidVINLetter;
// FE vin validation, not absolute vin validation
var isVinValid = function (vin) {
    if (vin === void 0) { vin = ''; }
    return !getInvalidVINLetter(vin) && vin.length === 17;
};
exports.isVinValid = isVinValid;
